module.exports = __webpack_public_path__ + "media/images/emblems/Coa_stgallen-6d87756d5a842c77799e6b7e16877e6b.svg";